module.exports = __webpack_public_path__ + "static/media/icon.816b9299.png";